/* eslint-disable */

import * as R from 'ramda'
import { CONFIG, FEATURES } from '../config'

if (CONFIG.SMARTY_ENV !== 'production') {
  console.info(
    `Running smarty-marketing in non-production mode (${CONFIG.SMARTY_ENV}) with app_id ${CONFIG.INTERCOM_APP_ID}`
  )
}

export const boot = (props) => {
  const w = window
  const ic = w.Intercom
  if (R.equals(typeof ic, 'function')) {
    ic('reattach_activator')
    ic('update', window.intercomSettings)
  } else {
    const d = document
    const i = function () {
      i.c(arguments)
    }
    i.q = []
    i.c = (args) => i.q.push(args)
    w.Intercom = i
    const l = () => {
      const s = d.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = `https://widget.intercom.io/widget/${CONFIG.INTERCOM_APP_ID}`
      // insert intercom script after the OneTrust script if its feature flag is on
      const i = FEATURES.ONE_TRUST_COOKIE_POLICY ? 2 : 0
      const x = d.getElementsByTagName('script')[i]
      x.parentNode.insertBefore(s, x)
    }
    if (w.attachEvent) {
      w.attachEvent('onload', l)
    } else {
      w.addEventListener('load', l, false)
    }
  }
  window.Intercom('boot', {
    app_id: CONFIG.INTERCOM_APP_ID,
    custom_launcher_selector: '#intercom_launcher',
    ...props,
  })
}

export const shutdown = () => {
  window.Intercom && window.Intercom('shutdown')
}

export const update = (props) => {
  window.Intercom && window.Intercom('update', props)
}
